import React from "react";
import { Link } from "react-router-dom";
import './index.css';
import logo from "../../images/logo.png";
import header_bg from "../../images/header_bg.png"
import uni_logo from "../../images/uni_logo.png"
import { Image } from 'antd';


class Header extends React.Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <>
                <div className="d-flex justify-content-between align-items-center" style={{ backgroundImage: `url(${header_bg})`, color: 'black', padding: "1rem 5rem", top: 0, left: 0, right: 0, position: "fixed", width: "100%", zIndex: 100 }}>
                    <Image preview={false} src={logo} />
                    <Image preview={false} src={uni_logo} />
                </div>
            </>
        )
    }
}

export default function Headers() {
    return (
        <Header />
    )
}
